export default __webpack_public_path__ + "static/media/landingInvites.e9648c8f.jpg";